import MatchMedia from './MatchMedia';

const ResponsiveUtil = (function() {
	var is_to_tablet = null;
	var is_desktop_up = null;

	var reloading = false;

	var update = function() {
		is_to_tablet = MatchMedia('(max-width: 900px)');
		is_desktop_up = MatchMedia('(min-width: 901px)');

		window.bodyWidth = document.documentElement.offsetWidth;
		Cookies.set('is_mobile', is_to_tablet);
		/*if (!reloading && is_tablet_max != config['commons']['is_mobile']) {
			reloading = true;
			window.location.reload();
		}*/
	};

	$(window).on('resize', update);
	update();

	return {
		isToTablet: function() {
			return is_to_tablet;
		},
		isDesktopUp: function() {
			return is_desktop_up;
		},
		hasNativeSelect: function() {
			return window.navigator.userAgent.match(/(iPad|iPhone|iPod)/i) &&
				!window.navigator.userAgent.match(/(Windows\sPhone)/i)
				? true
				: false;
		},
		isIE: function() {
			return window.navigator.userAgent.match(/(?:msie|trident)/i) ? true : false;
		},
		getMobileOperatingSystem: function () {
			var userAgent = navigator.userAgent || navigator.vendor || window.opera;

			if (/windows phone/i.test(userAgent)) {
				return "winphone";
			}

			if (/android/i.test(userAgent)) {
				return "android";
			}

			if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
				return "ios";
			}

			return "";
		}
	};
})();

export default ResponsiveUtil;
